import { InjectionToken } from '@angular/core';
import { environment } from '../../../../../environments/environment';

import { resolveSsoLoginUrl } from '../functions/sso-login-url.functions';

export const SSO_LOGIN_URL = new InjectionToken<string>('SSO_LOGIN_URL', {
  providedIn: 'root',
  factory: () => resolveSsoLoginUrl(environment.name, window.location.hostname),
});

export const AUTHENTICATION_REDIRECT = new InjectionToken<(url: string) => void>(
  'AUTHENTICATION_REDIRECT',
  {
    providedIn: 'root',
    factory: () => (url) => window.location.assign(url),
  },
);
